import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e3558e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "modal"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "만석 노선", -1 /* HOISTED */))
const _hoisted_5 = {
  ref: "scrollWrapper",
  class: "body",
  role: "list",
  "aria-label": "만석 노선 목록"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#center" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        appear: "",
        name: "slide-up"
      }, {
        default: _withCtx(() => [
          ($setup.showModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: $setup.onClickClose,
                    "aria-label": "닫기"
                  }, [
                    _createVNode($setup["InlineSvg"], {
                      src: require('@/assets/icons/x-icon.svg'),
                      alt: ""
                    }, null, 8 /* PROPS */, ["src"])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fullSeatLines, (line) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: line.id,
                      role: "listitem"
                    }, [
                      _createVNode($setup["FullSeatLineInfoRow"], {
                        lineInfo: line,
                        role: "link",
                        tabindex: "0",
                        onClick: _withModifiers(($event: any) => ($setup.goToLineInfoDetail(line)), ["prevent"]),
                        onKeydown: _withKeys(_withModifiers(($event: any) => ($setup.goToLineInfoDetail(line)), ["prevent"]), ["enter"]),
                        "aria-label": `${$setup.useGetLineRouteName(
                  line.lineTypeCode,
                  line.name,
                  line.no
                )} 노선 상세 화면으로 이동`
                      }, null, 8 /* PROPS */, ["lineInfo", "onClick", "onKeydown", "aria-label"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.scrollWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-wrapper",
            container: $setup.scrollWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}